module.exports = __webpack_public_path__ + "static/media/Ship.adbb8e54.png";